module.exports = __webpack_public_path__ + "c6d5e6fb0bd22e2421fa7418a8651fa0.png";